// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d211cbef","70":"99e50e7b","248":"b37aeec1","273":"10394eed","296":"e9722f5e","497":"c96f1e77","911":"b2ca89ca","930":"7efe6651"}[chunkId] + ".chunk.js";
};